import {Text} from '@eitje/web_components'
import {prettyPrintArray} from '@eitje/utils'

export const ArrayRow = ({item}) => {
	const values = [item.value].flat().filter(Boolean)
	const valueItems = item.ids ? values.map((value, index) => `${value} (${item.ids[index]})`) : item.value

	const formattedValue = prettyPrintArray({
		array: Array.isArray(valueItems) ? valueItems : [valueItems],
		quotes: false,
		joinWord: '&',
		sort: true,
	})

	return (
		<>
			<Text t={`records.default.fields.${item.description}`} infoIconMessage={item.infoIconMessage} />
			<Text>{formattedValue}</Text>
		</>
	)
}
